"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Section = _styledComponents.default.section`
  color: ${props => props.textColor || 'inherit'};
  background-color: ${props => {
  if (props.backgroundColor) {
    return props.backgroundColor;
  }
  return props.colorMode === 'dark' ? 'black' : 'transparent';
}};

  ${props => props.backgroundImage && `
    background-image: url(${props.backgroundImage}); 
    background-size: cover; 
    background-position: center center;
    `}

  p {
    a {
      text-decoration: none !important;
      color: ${props => props.textColor || 'inherit'};
      border-bottom: 1px solid ${props => props.textColor || 'inherit'};
      transition: 0.15s all;

      &:hover {
        opacity: 0.75;
      }
    }
  }

  a.bricks-cta {
    color: ${props => props.textColor || 'inherit'};
    border: 1px solid ${props => props.textColor || 'inherit'};

    &:hover {
      color: ${props => props.backgroundColor || 'inherit'};
      background-color: ${props => props.textColor || 'inherit'};
    }
  }

  a.shopping-carousel {
    color: ${props => props.textColor || 'inherit'};
    text-decoration: none;
  }

  div.credits-container {
    border-top: 1px solid ${props => props.textColor || 'inherit'};
    svg path {
      stroke: ${props => props.textColor || 'inherit'};
    }
  }

  /* .article-aggregator {
    color: ${props => props.colorMode === 'dark' ? 'white' : 'black'};
    text-decoration: none;
  }
  p.article-aggregator-cta {
    color: ${props => props.colorMode === 'dark' ? 'white' : 'black'};
    border-color: ${props => props.colorMode === 'dark' ? 'white' : 'black'};
  } */
`;
exports.Section = Section;
//# sourceMappingURL=styles.js.map